export const FETCH_POSTS = 'FETCH_POSTS';
export const UPDATE_POST = 'UPDATE_POST';
export const DELETE_POST = 'DELETE_POST';
export const CREATE_POST = 'CREATE_POST';


export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const FETCH_CATEGORY  = 'FETCH_CATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAIL = 'UPDATE_CATEGORY_FAIL';

export const FETCH_MEDIAGROUPS = 'FETCH_MEDIAGROUPS';
export const FETCH_MEDIAGROUP  = 'FETCH_MEDIAGROUP';
export const UPDATE_MEDIAGROUP = 'UPDATE_MEDIAGROUP';
export const DELETE_MEDIAGROUP = 'DELETE_MEDIAGROUP';
export const CREATE_MEDIAGROUP = 'CREATE_MEDIAGROUP';
export const UPDATE_MEDIAGROUP_SUCCESS = 'UPDATE_MEDIAGROUP_SUCCESS';
export const UPDATE_MEDIAGROUP_FAIL = 'UPDATE_MEDIAGROUP_FAIL';

export const FETCH_PROVIDERS = 'FETCH_PROVIDERS';
export const FETCH_PROVIDER  = 'FETCH_PROVIDER';
export const UPDATE_PROVIDER = 'UPDATE_PROVIDER';
export const DELETE_PROVIDER = 'DELETE_PROVIDER';
export const CREATE_PROVIDER = 'CREATE_PROVIDER';
export const UPDATE_PROVIDER_SUCCESS = 'UPDATE_PROVIDER_SUCCESS';
export const UPDATE_PROVIDER_FAIL = 'UPDATE_PROVIDER_FAIL';

export const FETCH_PERSONS = 'FETCH_PERSONS';
export const FETCH_PERSON  = 'FETCH_PERSON';
export const UPDATE_PERSON = 'UPDATE_PERSON';
export const DELETE_PERSON = 'DELETE_PERSON';
export const CREATE_PERSON = 'CREATE_PERSON';
export const UPDATE_PERSON_SUCCESS = 'UPDATE_PERSON_SUCCESS';
export const UPDATE_PERSON_FAIL = 'UPDATE_PERSON_FAIL';

export const FETCH_SEGMENTS = 'FETCH_SEGMENTS';
export const FETCH_SEGMENT  = 'FETCH_SEGMENT';
export const UPDATE_SEGMENT = 'UPDATE_SEGMENT';
export const DELETE_SEGMENT = 'DELETE_SEGMENT';
export const CREATE_SEGMENT = 'CREATE_SEGMENT';
export const UPDATE_SEGMENT_SUCCESS = 'UPDATE_SEGMENT_SUCCESS';
export const UPDATE_SEGMENT_FAIL = 'UPDATE_SEGMENT_FAIL';


export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_PRODUCT  = 'FETCH_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAIL = 'UPDATE_PRODUCT_FAIL';


export const FETCH_PRODUCTTYPES = 'FETCH_PRODUCTTYPES';
export const FETCH_PRODUCTTYPE  = 'FETCH_PRODUCTTYPE';
export const UPDATE_PRODUCTTYPE = 'UPDATE_PRODUCTTYPE';
export const DELETE_PRODUCTTYPE = 'DELETE_PRODUCTTYPE';
export const CREATE_PRODUCTTYPE = 'CREATE_PRODUCTTYPE';
export const UPDATE_PRODUCTTYPE_SUCCESS = 'UPDATE_PRODUCTTYPE_SUCCESS';
export const UPDATE_PRODUCTTYPE_FAIL = 'UPDATE_PRODUCTTYPE_FAIL';


export const UPDATE_USERPROFILE = 'UPDATE_USERPROFILE';
export const FETCH_ACCOUNT = 'FETCH_ACCOUNT';



// WEBPACK FOOTER //
// ./src/actions/types.js